import React from 'react'
import { useParams } from 'react-router-dom'
import { Box } from '@mui/material'

import OrderPaymentList from './OrderPaymentList'

function FinanceV2Tab() {
  const { id } = useParams()

  return (
    <Box>
      <OrderPaymentList customerId={id} />
    </Box>
  )
}

export default FinanceV2Tab
